import React, { FC, useEffect, useState } from 'react';
import { Table, Modal, Col, Input, Form, Avatar, Spin } from 'antd';
import { DeleteOutlined, EditOutlined, UserOutlined } from '@ant-design/icons';

import styled from 'styled-components';
import { useLazyQuery, useMutation } from '@apollo/client';
import { GET_ALL_USERS } from '../../Apollo/graphql/Query/GetUsers';
import { DELETE_USER, EDIT_USER } from '../../Apollo/graphql/Mutation/UserMutations';

const UserContainer = styled(Col)`
`

interface UProps {
    _id?: string
    firstName?: string
    email?: string
    role?: string
}

const UserLists: FC = () => {
    const [users, setUsers] = useState();
    const [isEditing, setIsEditing] = useState(false);
    const [editingUser, setEditingUser] = useState<UProps>({});
    const [totalPage, setTotalPage] = useState<any>(1);
    const [currentPage, setCurrentPage] = useState<any>(1);
    const PAGE_LIMIT = 10;
    // const [openProfile, setOpenProfile] = useState(false);
    const [deleteUserMutation] = useMutation(DELETE_USER, {
        onCompleted: data => {
        }
    });
    const [editUserMutation] = useMutation(EDIT_USER, {
        onCompleted: data => {
        },
    });

    const [getUsers, { loading, data }] = useLazyQuery(GET_ALL_USERS, {

        onCompleted: (data) => {
            setTotalPage(data?.users?.pagination?.total);
            setUsers(data?.users?.users);
        },
        onError: (err) => {
            console.log(err);
        },
        notifyOnNetworkStatusChange: true,
    })
    useEffect(() => {
        getUsers({
            variables: {
                pagination: {
                    page: currentPage,
                    limit: 10
                },
            },
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage])

    const columns = [
        {
            title: "Avatar",
            dataIndex: "",
            key: "x",
            render: (record) => {
                return <Avatar size="large" icon={record?.avatarUrl || <UserOutlined />} />
            }
        },
        // { title: "ID", dataIndex: "_id", key: "_id" },
        { title: "FirstName", dataIndex: "firstName", key: "firstName" },
        { title: "Email", dataIndex: "email", key: "email" },
        { title: "Role", dataIndex: "role", key: "role" },
        {
            title: "Action",
            dataIndex: "",
            key: "x",
            render: (record: any) => {
                return <>
                    <EditOutlined onClick={() => onEditUser(record)} style={{ color: "green", marginLeft: '1.5rem' }} />
                    <DeleteOutlined onClick={() => onDeleteUser(record)} style={{ color: "red", marginLeft: '1.5rem' }} />
                </>
            }
        }
    ]


    const onDeleteUser = (record: any) => {
        Modal.confirm({
            title: "Are you sure to delete user?",
            okText: "Yes",
            okType: "danger",
            onOk: () => {

                deleteUserMutation({
                    variables: {
                        userId: record._id
                    }, refetchQueries: [{ query: GET_ALL_USERS }]
                })
            }
        })
    }
    const onEditUser = (record: any) => {
        setIsEditing(true);
        setEditingUser({ ...record })
    }
    const resetEditing = () => {
        setIsEditing(false);
        setEditingUser({});
    }
    return (
        <Spin spinning={loading}>
            <UserContainer>
                {data &&
                    <Table
                        columns={columns}
                        dataSource={users}
                        pagination={{
                            position: ['bottomCenter'],
                            current: currentPage,
                            total: totalPage,
                            showSizeChanger: false,
                            defaultPageSize: PAGE_LIMIT,
                            onChange: (page) => {
                                setCurrentPage(page);
                            }
                        }}
                    >
                    </Table>
                }
                <Modal
                    title="Edit User"
                    okText="Save"
                    visible={isEditing}
                    onCancel={() => {
                        resetEditing()
                    }}
                    onOk={() => {
                        editUserMutation({
                            variables: {
                                userId: editingUser._id,
                                input: {
                                    email: editingUser.email,
                                    firstName: editingUser.firstName
                                },
                                refetchQueries: [{ query: GET_ALL_USERS }]
                            },
                        })
                        resetEditing();
                    }}
                >
                    <Form
                    >
                        <Form.Item
                            label="Name"
                        >
                            <Input
                                value={editingUser?.firstName}
                                disabled
                                onChange={(e) => {
                                    setEditingUser(pre => {
                                        return { ...pre, firstName: e.target.value }
                                    })
                                }}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Email"
                        >
                            <Input
                                value={editingUser?.email}
                                disabled
                                onChange={(e) => {
                                    setEditingUser(pre => {
                                        return { ...pre, email: e.target.value }
                                    })
                                }}
                            />
                        </Form.Item>
                        {/* <Form.Item
                            label="role"
                        >

                            <Input
                                value={editingUser?.role}
                                disabled
                                onChange={(e) => {
                                    setEditingUser(pre => {
                                        return { ...pre, role: e.target.value }
                                    })
                                }}
                            />
                        </Form.Item> */}
                    </Form>
                </Modal>
                {/* <Modal
                title= "Profile"
                onCancel={() => {
                    setOpenProfile(false)
                }}
                onOk={() => {
                    setOpenProfile(false);
                }}
                visible={openProfile}>
                </Modal> */}
            </UserContainer>
        </Spin>
    )
}

export default UserLists;